<h5 *ngIf="!PROD_MODE" class="m-0">
  <span class="dev-label badge badge-info">DEV</span>
</h5>
<router-outlet></router-outlet>
